import React, {ReactNode} from "react"
import {Result} from "antd"
import Button from "../../components/Button"
import {useNavigate} from "react-router-dom"

type ErrorPageStatuses =
  | "success"
  | "error"
  | "info"
  | "warning"
  | "404"
  | "403"
  | "500"

interface ErrorPageProps {
  title?: ReactNode
  subTitle?: ReactNode
  status?: ErrorPageStatuses
  extra?: ReactNode
  icon?: ReactNode
  style?: React.CSSProperties
}

const ErrorPage: React.FC<ErrorPageProps> = ({extra, ...props}) => {
  const navigate = useNavigate()
  return (
    <Result
      {...props}
      extra={
        extra ? (
          extra
        ) : (
          <Button
            onClick={() => navigate("/")}
            style={{margin: "0 auto"}}
            buttonType={"primary"}
          >
            Вернуться на главную
          </Button>
        )
      }
    />
  )
}

export default ErrorPage
